module.exports = __webpack_public_path__ + "img/iron_talon.de0050fa.png";